import { BaseSearchParametersModel } from "../../models/base-search-parameters.model";

export class SearchParametersModel extends BaseSearchParametersModel {
    public templateId?: string;
    public categories: Array<string>;
    public attributeIds: Array<string>;
    public locationIds: Array<string>;
}
